import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {LangChange} from '../../../../../../lang-change';
import {Utils} from '../../../../../../common/services/Utils';
import {EnrollCabinet} from '../../../model/enroll-cabinet';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material';
import {Language} from '../../../../../../common/models/language';
import {FileService} from '../../../../../shared/services/file.service';
import {FileServiceModerator} from '../../../../../moderator/services/file-service-moderator.service';

@Component({
  selector: 'app-enroll-military-registration-info',
  templateUrl: './enroll-military-registration-info.component.html',
  styleUrls: ['./enroll-military-registration-info.component.scss']
})
export class EnrollMilitaryRegistrationInfoComponent extends LangChange implements OnInit {

  maxFileSize = 5012000;

  constructor(public _translateService: TranslateService,
              private fileService: FileService,
              private fileModeratorService: FileServiceModerator,
              private dialog: MatDialog,
              private utils: Utils) {
    super(_translateService);
  }

  @Input() public data: EnrollCabinet;
  @Input() public dics: any;
  @ViewChild('photoFileInput') fileInputVariable;
  @Input() public applicationFormDisabled: boolean;

  onLangChange(language: Language): void {
  }

  ngOnInit() {
  }

  fileInputChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      if (fileInput.target.files[0].size > this.maxFileSize) {
        this.utils.notifyError('enroll_cabinet_page.upload_file_size_exceed', null);
        return false;
      } else {
        const file: File = fileInput.target.files[0];
        const formData = new FormData();
        formData.append('file', file, file.name);
        this.fileModeratorService.uploadFile(formData).subscribe(res => {
          this.data.military_registration_data.military_registration_id_scan = res;
        });
      }
    }
  }

  deleteFile(fileId: any) {
    this.utils.confirmDialog({message: 'delete_confirmation'}, () => {
      this.fileModeratorService.deleteFile(fileId).subscribe(res => {
        this.data.military_registration_data.military_registration_id_scan.fileId = null;
      });
    });
  }

  getFile(id: any) {
    this.utils.blockStart(null);
    this.fileService.getFileInfo(id).subscribe((fileInfo) => {
      this.fileService.getFile(fileInfo.fileId).subscribe((data) => {
        this.fileService.downloadPsFile(data, fileInfo);
        this.utils.blockStop();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-military-registration-info/enroll-military-registration-info.component.ts